import { makeStyles } from "@fluentui/react-components";
import { $gray200, $gray800 } from "../../../../cssjs/colors";

export const useTableStyles = makeStyles({
  tableContainer: {
    width: "100%",
    overflowX: "auto",
    overflowY: "auto",
    height: "477px",
    whiteSpace: "nowrap",
    borderCollapse: "collapse",
  },
  thead: {
    borderBottom: `2px solid ${$gray200}`,
    borderTop: `2px solid rgb(204, 204, 204)`,
    userSelect: "none",
    minWidth: "250px",
  },
  stickyHeader: {
    position: "sticky",
    top: "0px",
    backgroundColor: "white",
    zIndex: 1000,
    boxShadow:
      "0 2px 2px -1px rgba(0, 0, 0, 0.6),  0 -2px 2px -1px rgba(0, 0, 0, 0.6)",
  },
  tbody: {
    "& tr": {
      scrollMarginTop: "88px",
    },
  },
  table: {
    borderCollapse: "collapse",
  },
  trow: {
    borderBottom: `1px solid ${$gray800}`,
  },
  tdata: {
    paddingLeft: "14px",
    textAlign: "left",
  },
});
